import React from "react";

const Why = () => {
  const reasons = [
    "Solutions tailored to your business size and needs",
    "Dedicated account manager and support team",
    "Flexible pricing and deployment options",
    "Continuous updates and access to the latest AI tools",
    "Exclusive workshops and executive briefings",
    "Integration with existing enterprise systems",
  ];

  const leftColumn = reasons.slice(0, 3);
  const rightColumn = reasons.slice(3);

  return (
    <div className="bg-black text-white py-10 sm:py-20 lg:py-20">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-400 mb-4">
            Excellence
          </p>
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-thin mb-4">
            Why Choose Our <em className="text-gray-300">Enterprise Solutions?</em>
          </h2>
          <p className="text-sm sm:text-base md:text-lg font-light leading-relaxed max-w-3xl mx-auto text-gray-300 mt-1">
            We partner with you to deliver measurable value, scalable adoption, and long-term impact across your organization.
          </p>
        </div>

        {/* Reasons */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 sm:gap-14 lg:gap-16">
          {/* Left column */}
          <div className="space-y-8 sm:space-y-10">
            {leftColumn.map((reason, index) => (
              <div key={index} className="group">
                <div className="border-l border-gray-800 pl-6 sm:pl-8 h-full">
                  <div className="mb-4 sm:mb-6">
                    <div className="w-2 h-2 bg-white rounded-full -ml-7 sm:-ml-9 mb-4 sm:mb-6" />
                    <h3 className="text-sm sm:text-base md:text-md font-light tracking-wide mb-1 sm:mb-2 group-hover:text-gray-300 transition-colors">
                      {reason}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Right column */}
          <div className="space-y-8 sm:space-y-10">
            {rightColumn.map((reason, index) => (
              <div key={index} className="group">
                <div className="border-l border-gray-800 pl-6 sm:pl-8 h-full">
                  <div className="mb-4 sm:mb-6">
                    <div className="w-2 h-2 bg-white rounded-full -ml-7 sm:-ml-9 mb-4 sm:mb-6" />
                    <h3 className="text-sm sm:text-base md:text-md font-light tracking-wide mb-1 sm:mb-2 group-hover:text-gray-300 transition-colors">
                      {reason}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Why;
